t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_more_activity_button')

module.exports = ->
  t.mustacheBlockInverted 'hasCount', =>
    t.format 'view-all-activity-ellipsis'

  t.mustacheBlock 'hasCount', =>
    t.format 'view-all-unread-activity-count-ellipsis', { count: t.mustacheVar('count') }
